import {Pipe, PipeTransform} from '@angular/core';

/**
 * Truncates and adds ellipses to the string or array if it exceeds the length provided by the optional "size" parameter.
 * For array size will be number of elements
 * For string size will be number of characters
 *
 * Usage:
 *    input | ellipsize
 *    input | ellipsize : 12
 *    [13232,122,42,11] | ellipsize : 2
 *    'Lorem ipsum' | ellipsize : 4
 */
@Pipe({
  name: 'ellipsize',
  standalone: true
})
export class EllipsizePipe implements PipeTransform {

    transform<T extends {length: number, slice(number, any): any}>(input: T, size = 250): string {
        if (input?.length > size) {
            return input?.slice(0, size) + '\u2026';
        }

        return (typeof input?.toString === 'function') ? input?.toString() : '';
    }

}
